import "./style.scss";
import "@splidejs/splide/dist/css/splide.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "aos/dist/aos.css";

import { initSliders } from './js/sliders'
import { initMasonry } from "./js/masonry";
import { initLightbox } from './js/lightbox'
import { initFormSuccess } from "./js/contact-form";

initSliders()
initMasonry()
initLightbox()
initFormSuccess()

AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
  initClassName: "aos-init", // class applied after initialization
  animatedClassName: "aos-animate", // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 200, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 1000, // values from 0 to 3000, with step 50ms
  easing: "ease", // default easing for AOS animations
  once: true, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: "top-buttom", // defines which position of the element regarding to window should trigger the animation
});

document.addEventListener("DOMContentLoaded", () => {
  const menuToggle = document.querySelector("button.main-menu-toggle");
  const mobileMenu = document.querySelector(".mobile-menu-container");
  const mobileMenuSurface = document.querySelector(
    ".mobile-menu-container .gr"
  );
  if (
    menuToggle !== undefined &&
    mobileMenu !== undefined
  ) {
    menuToggle.addEventListener("click", () => {
      mobileMenu.classList.toggle("open");
      menuToggle.classList.toggle("open");
    });
    mobileMenuSurface.addEventListener("click", () => {
      mobileMenu.classList.remove("open");
      menuToggle.classList.toggle("open");
    });
  }


  // Read more text container
  var readmoreToggle = document.querySelectorAll(
    ".texteditor-content-readmore-container"
  );
  readmoreToggle.forEach((item) => {
    var readmoreToggleBtn = item.querySelector(".btn-read-more");
    var readmoreToggleText = item.querySelector(".btn-text");
    readmoreToggleBtn.addEventListener("click", (event) => {
      // event.stopPropagation()
      console.log(event.target);
      readmoreToggleBtn.classList.toggle("open");
      item.classList.toggle("open");
      if (readmoreToggleText.innerHTML === "aufklappen") {
        readmoreToggleText.innerHTML = "schließen";
      } else {
        readmoreToggleText.innerHTML = "aufklappen";
      }
    });
  });



  // Mobile Menu
  var mobileMenuItems = document.querySelectorAll(
    ".mobile-menu li.menu-item-has-children"
  );
  mobileMenuItems.forEach((item) => {
    item.addEventListener("click", (event) => {
      event.stopPropagation();
      console.log(event.target);
      const submenu = event.target.querySelector(".sub-menu");
      submenu.classList.toggle("visible");
    });
  });

  // Smooth scroll on page
  if (
    window.location.hash !== "" &&
    document.querySelector(window.location.hash)
  ) {
    window.scrollTo(0, 0); // Checkmate browser behavior
    const headerHeight = document.querySelector(".fixed-nav-bar").offsetHeight;
    window.scroll({
      top:
        document.querySelector(window.location.hash).offsetTop - headerHeight,
      behavior: "smooth",
    });
  }
});

// Mobile Menu
var mobileMenuItems = document.querySelectorAll(
  ".mobile-menu li.menu-item-has-children"
);
mobileMenuItems.forEach((item) => {
  item
    .querySelector(".mobile-menu-arrow")
    .addEventListener("click", (event) => {
      event.stopPropagation();
      event.preventDefault();
      const submenu = item.querySelector(".sub-menu");
      submenu.classList.toggle("visible");
    });
});

var header = document.getElementById("fixed-header");
var headerfixedbar = document.getElementById("fixed-header-bar");
var sticky = headerfixedbar.offsetTop;

function stickyheaderFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("fixed");
  } else {
    header.classList.remove("fixed");
  }
}

let lastKnownScrollPosition = 0;
let ticking = false;

function toggleToTopButton(scrollPos) {
  const toTopButton = document.querySelector(".to-top-button");
  if (
    scrollPos > 0 &&
    scrollPos + window.innerHeight < document.body.offsetHeight
  ) {
    toTopButton.classList.add("visible");
  } else {
    toTopButton.classList.remove("visible");
  }
}

document.addEventListener("scroll", (e) => {
  lastKnownScrollPosition = window.scrollY;

  // Throttle scroll events for performance reasons
  if (!ticking) {
    window.requestAnimationFrame(() => {
      stickyheaderFunction();
      toggleToTopButton(lastKnownScrollPosition);
      ticking = false;
    });

    ticking = true;
  }
});

// Smooth Scrolling
const anchorLinks = document.querySelectorAll('a[href^="#"]');
anchorLinks.forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault();
    const headerHeight = document.querySelector(".fixed-nav-bar").offsetHeight;
    const href = link.getAttribute("href");
    const scrollingTo = document.querySelector(href);
    if (scrollingTo) {
      const offsetTop = scrollingTo.offsetTop;
      window.scroll({
        top: offsetTop - headerHeight,
        behavior: "smooth",
      });
    }
  });
});

// Check if sub menus exit viewport
const isFullyInViewport = (el) => {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

let observer = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (isFullyInViewport(entry.target) === false) {
      entry.target.style.right = 0;
      observer.unobserve(entry.target);
    }
  });
});

document.querySelectorAll(".desktop-menu .sub-menu").forEach((submenu) => {
  observer.observe(submenu);
});

// Filter für Standortseiten
if (document.querySelector(".filter-button-container")) {
  const filterButtons = document.querySelectorAll(".filter-button");
  filterButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      const cardContainer = document.querySelector('.service-cards')
      if(cardContainer && !cardContainer.classList.contains('fading')) {
        cardContainer.classList.add('fading')
        setTimeout(() => {
          cardContainer.classList.remove('fading')
        }, 300)
      }

      const filterIds = button.getAttribute("data-type");

      button.classList.add("active");
      filterButtons.forEach((button) => {
        if (button !== event.target) {
          button.classList.remove("active");
        }
      });

      document
        .querySelectorAll(".service-card-container")
        .forEach((service) => {
          if (
            filterIds.indexOf(service.getAttribute("data-type")) != -1 ||
            filterIds === ""
          ) {
            setTimeout(() => {
              service.style.display = 'flex'
            }, 300)
          } else {
            setTimeout(() => {
              service.style.display = 'none'
              AOS.refresh()
            }, 300)
          }
        });
    });
  });
}
  